import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sort-columns"
export default class extends Controller {
  static targets = ["sort-columns", "link"];

  showLoader() {
    const loader = document.getElementById("content-summary-loader");
    if (loader) {
      loader.style.display = "block";
    }
    const loaderMobile = document.getElementById(
      "content-summary-loader-mobile"
    );
    if (loaderMobile) {
      loaderMobile.style.display = "block";
    }
  }

  updateUrl(event) {
    const clickedLink = event.currentTarget;
    const url = new URL(clickedLink.href, window.location.origin);

    // read current direction of the clicked link
    const currentDir = url.searchParams.get("direction") || "asc";
    const nextDir = currentDir === "asc" ? "desc" : "asc";

    // reset all other links back to asc
    this.linkTargets.forEach((link) => {
      if (link !== clickedLink) {
        const u = new URL(link.href, window.location.origin);
        u.searchParams.set("direction", "asc");
        link.href = u.toString();
      }
    });

    // delay updating clicked link (so request still goes with current direction)
    setTimeout(() => {
      url.searchParams.set("direction", nextDir);
      clickedLink.href = url.toString();
    });
  }
}
